"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// Waist Circumference
export default class WaistManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$waistSummary = $('#waist_summary');
        this.$waistSummaryValue = $('#waist_summary_value');

        this.$waistOutputCellLabel = $('#waist_output_cell_label');
        this.$waistOutputCellValue = $('#waist_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$waistOutputCellIcon = $('#waist_output_cell_icon');

        this.waistHelper = new ManagerHelper('waist', this.controller, this.updateWaistAgeInfluence.bind(this));
    }

    reconfigureWaistInput() {
        if (this.waistHelper) {
            this.waistHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.waistHelper) {
            this.waistHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateWaistAgeInfluence(waist = this.controller.current_values.waist) {
        if (isset(waist) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForValue('waist', waist, this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateWaistOutput(response);
        } else {
            this.populateWaistOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateWaistOutput(response) {
        const waistOutput = generateValueOutput('waist', response, this.controller);

        this.controller.current_age_changes.waist = waistOutput.ageChange;
        this.controller.current_values.waist_change = waistOutput.ageChangeText

        this.$waistSummary.html(waistOutput.summary);
        this.$waistSummaryValue.html(waistOutput.summaryValue);

        this.$waistOutputCellLabel.html(waistOutput.outputCellLabel);
        this.$waistOutputCellValue.html(waistOutput.outputCellValue).css('color', waistOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$waistOutputCellIcon.prop('src', waistOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.waistHelper.enableControls(enable);
    }

}
